import React from 'react';

import ContentBlockCard from './ContentBlockCard';

export interface Feature {
    id?: string | number;
    title?: string;
    description?: string;
    linkUrl?: string;
}

export interface ContentBlockListProps {
    features?: Feature[];
    buttonLabel?: string;
}

export const ContentBlockList = ({ features = [], buttonLabel }: ContentBlockListProps) => {
    return (
        <div className="grid md:grid-cols-3 gap-8 w-full max-w-7xl mx-6 md:mx-12 lg:mx-[94px]">
            {features.map((feature, index) => (
                <ContentBlockCard
                    key={feature.id || index}
                    title={feature.title}
                    description={feature.description}
                    linkUrl={feature.linkUrl}
                    buttonLabel={buttonLabel}
                />
            ))}
        </div>
    );
};

export default ContentBlockList;
